import { render, staticRenderFns } from "./IconLinkBoxesContainer.vue?vue&type=template&id=f5936c66&scoped=true"
import script from "./IconLinkBoxesContainer.vue?vue&type=script&lang=js"
export * from "./IconLinkBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./IconLinkBoxesContainer.vue?vue&type=style&index=0&id=f5936c66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5936c66",
  null
  
)

export default component.exports